module.exports = __webpack_public_path__ + "img/btn_menu_tljdh_c.f30308e0.png";